import {
  useGetFailuresQuery,
  useRetryFailureMutation,
  useDeleteFailureMutation,
} from "../generated/graphql";
import { format } from "date-fns";
import { Button } from "../components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";

export default function Failures() {
  const [{ data, fetching }, refetch] = useGetFailuresQuery();
  const [, retryFailure] = useRetryFailureMutation();
  const [, deleteFailure] = useDeleteFailureMutation();

  const handleRetry = async (id: number) => {
    const result = await retryFailure({ id });
    if (result.data?.retryFailure) {
      refetch({ requestPolicy: "network-only" });
    }
  };

  const handleDelete = async (id: number) => {
    const result = await deleteFailure({ id });
    if (result.data?.deleteFailure) {
      refetch({ requestPolicy: "network-only" });
    }
  };

  if (fetching) {
    return (
      <div className="container mx-auto p-4">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <div className="my-8">
        <h1 className="text-3xl font-bold mb-6">Failures</h1>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>ID</TableHead>
                <TableHead>Key</TableHead>
                <TableHead>Message</TableHead>
                <TableHead>Error</TableHead>
                <TableHead>Stack</TableHead>
                <TableHead>Created At</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data?.getFailures.map((failure) => (
                <TableRow key={failure.id}>
                  <TableCell>{failure.id}</TableCell>
                  <TableCell>{failure.key}</TableCell>
                  <TableCell>{failure.message || "-"}</TableCell>
                  <TableCell>{failure.error || "-"}</TableCell>
                  <TableCell>{failure.stack || "-"}</TableCell>
                  <TableCell>
                    {format(new Date(failure.createdAt), "PPpp")}
                  </TableCell>
                  <TableCell>
                    <div className="flex gap-2">
                      <Button
                        variant="default"
                        size="sm"
                        onClick={() => handleRetry(failure.id)}
                      >
                        Retry
                      </Button>
                      <Button
                        variant="destructive"
                        size="sm"
                        onClick={() => handleDelete(failure.id)}
                      >
                        Delete
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
